export default __webpack_public_path__ + "static/media/Clínica-Canoas.9892c340.png";